import { observable, action } from "mobx";
import { logger } from "@root/lib/telemetry";
import { optimizelyStore } from "./optimizely-store";
import { OptimizelyEventNames } from "@lib/common-interfaces";

export class IntercomStore {
  @observable
  public isVisible: boolean = false;

  @observable
  public unreadCount: number = 0;

  constructor() {
    this.setupListeners();
  }

  private setupListeners(): void {
    const Intercom = (window as any).Intercom;
    if (Intercom) {
      Intercom("onHide", () => {
        this.setIsVisible(false);
      });

      Intercom("onShow", () => {
        this.setIsVisible(true);
        optimizelyStore.track(OptimizelyEventNames.open_support_form);
        logger.info("intercom/support_opened");
      });

      Intercom("onUnreadCountChange", (unreadCount) => {
        this.setUnreadCount(unreadCount);
      });
    }
  }

  @action
  protected setIsVisible(visible: boolean): void {
    this.isVisible = visible;
  }

  @action
  protected setUnreadCount(unreadCount: number): void {
    this.unreadCount = unreadCount;
  }
}

export const intercomStore = new IntercomStore();
